/**
 * Deepgram nova-3 keyterms — the equivalent of AWS Transcribe's `CareAnd`
 * custom vocabulary. Keyterm prompting biases recognition toward these domain
 * terms so Deepgram matches the boost AWS already gets from its vocabulary.
 *
 * SEED LIST — high-frequency drugs / labs / terms most often mangled or
 * dropped. The full parity move is to export the AWS `CareAnd` vocabulary
 * (AWS Transcribe GetVocabulary) and merge it here; until then this covers the
 * most impactful terms. Keep the list focused — nova-3 keyterm quality
 * degrades past ~100 terms.
 */
export const DEEPGRAM_KEYTERMS: string[] = [
  // Medications (commonly mishheard in pilot transcripts)
  'escitalopram',
  'citalopram',
  'sertraline',
  'venlafaxine',
  'bupropion',
  'Wellbutrin',
  'pregabalin',
  'gabapentin',
  'quetiapine',
  'trazodone',
  'Dayvigo',
  'Quviviq',
  'metformin',
  'levothyroxine',
  'Synthroid',
  'rosuvastatin',
  'atorvastatin',
  'Ozempic',
  'semaglutide',
  'Mounjaro',
  'Zepbound',
  'tamsulosin',
  'Flomax',
  'spironolactone',
  'clindamycin',
  'nitrofurantoin',
  'cephalexin',
  'doxycycline',
  'amoxicillin',
  'FeraMAX',
  'Blexten',
  'Ryaltris',
  'Vyvanse',
  'dextroamphetamine',
  'Accutane',
  'isotretinoin',
  'naproxen',
  'Mirena',
  'Kyleena',
  // Labs / measures
  'ferritin',
  'lipoprotein',
  'triglycerides',
  'creatinine',
  'hemoglobin',
  'A1C',
  'TSH',
  'cortisol',
  'B12',
  'calprotectin',
  'ApoB',
  // Conditions / terms
  'lymphadenopathy',
  'hordeolum',
  'chalazion',
  'sonohysterogram',
  'echocardiogram',
  'PCOS',
  'CVID',
  'fibroid',
  'presyncope',
  'cellulitis',
  'folliculitis',
  // Clinic
  'Care&',
  'nurse practitioner',
];
